import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";

import {
  useGetAccountOrganizationsQuery,
  usePutAcceptOrgInviteMutation,
  usePutCancelRequestMutation,
  usePutLeaveOrgMutation,
  usePutRequestOrgMembershipMutation,
  usePutResendMembershipRequestMutation,
} from "../api/organizations.api";

export const useOrganizationQueries = () => {
  const [requestMembership, requestStatus] =
    usePutRequestOrgMembershipMutation();
  const [acceptInvite, acceptStatus] = usePutAcceptOrgInviteMutation();
  const [resendMembershipRequest, resendStatus] =
    usePutResendMembershipRequestMutation();
  const [cancelMembershipRequest, cancelStatus] = usePutCancelRequestMutation();
  const [leaveOrganization, leaveStatus] = usePutLeaveOrgMutation();

  const updateStatus = [
    requestStatus,
    acceptStatus,
    resendStatus,
    cancelStatus,
    leaveStatus,
  ];
  const isLoading = updateStatus.reduce<boolean>(
    (total, state) => total || state.isLoading,
    false
  );
  const isError = updateStatus.reduce<boolean>(
    (total, state) => total || state.isError,
    false
  );
  const isSuccess = updateStatus.reduce<boolean>(
    (total, state) => total || state.isSuccess,
    false
  );
  const errors = updateStatus.reduce<(FetchBaseQueryError | SerializedError)[]>(
    (total, state) => (state.error ? [...total, state.error] : total),
    []
  );

  return {
    useGetAccountOrganizationsQuery,
    requestMembership,
    acceptInvite,
    resendMembershipRequest,
    cancelMembershipRequest,
    leaveOrganization,
    isLoading,
    isError,
    errors,
    isSuccess,
  };
};
